<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'PAYER-BILLING'" [breadcrumb]="''" [count]="count"
    icon="fa-money-bill">
</app-breadcrumb>

<!-- body -->
<div class="content-background p-0">
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab title="{{ 'INVOICES' | translate }}" [selected]="true">
            <ng-template kendoTabContent>
                <div class="row mt-2">
                    <div class="col-sm-12">
                        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                            <app-advanced-mode id="payerBillingGridAdvancedSwitch" [storageKey]="'payer-billing-list'"
                                (collapsibleToggle)="enableAdvanced=$event">
                            </app-advanced-mode>
                            <input #search kendoTextBox class="ml-4 button-search"
                                placeholder="{{ 'SEARCH-INVOICE' | translate }}"
                                (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-INVOICE' | translate }}" />
                            <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
                        </div>
                    </div>
                </div>
                <div class="mt-2 ml-3 mr-3">
                    <kendo-grid #grid [data]="gridView" [navigable]="true"
                        [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                        [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort"
                        [filter]="state.filter" [sortable]="true" [filterable]="enableAdvanced"
                        [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
                        [kendoGridSelectBy]="'id'" [selectedKeys]="selectedInvoiceKeys"
                        (dblclick)="dblClickInvoice($event)" (selectedKeysChange)="onSelectedKeysChange($event)"
                        [selectable]="{ mode: 'multiple'}" (dataStateChange)="dataStateChange($event);"
                        (selectionChange)="onSelectionChange($event)">
                        <kendo-grid-messages noRecords="{{ 'NO-INVOICES' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="5"
                            class="text-center" headerClass="text-center">
                            <ng-template kendoGridHeaderTemplate>
                                <div class="w-100">
                                    <input id="selectAllCheckboxId" kendoGridSelectAllCheckbox [state]="selectAllState"
                                        (selectAllChange)="onSelectAllChange($event)" type="checkbox" kendoCheckBox />
                                    <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
                                </div>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
                                <input *ngIf="canDeleteInvoice(dataItem.invoiceStatus)"
                                    [kendoGridSelectionCheckbox]="idx" type="checkbox" kendoCheckBox />
                            </ng-template>
                        </kendo-grid-checkbox-column>
                        <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
                            <button kendoButton (click)="refresh()" class="float-right">
                                {{'GRID-REFRESH' | translate }}<i class="far fa-sync-alt mt-1"></i>
                            </button>
                            <button class="float-right" kendoButton [primary]="true" type="button"
                                [disabled]="getSelectedCount() === 0" (click)="openDeleteInvoicesDialogOpened()">
                                {{'DELETE-INVOICES' | translate }}<span *ngIf="getSelectedCount() > 0"
                                    class="ml-1">({{getSelectedCount()}})</span>
                            </button>
                        </ng-template>
                        <kendo-grid-column class="ellipsis-text" field="invoiceNumber"
                            title="{{ 'INVOICE-NUMBER' | translate }}" [width]="15">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.invoiceNumber}}">{{dataItem.invoiceNumber}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column class="ellipsis-text" field="payerName"
                            title="{{ 'PAYER-NAME' | translate }}" [width]="20">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.payerName}}">{{dataItem.payerName}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column class="ellipsis-text" field="feeSchedulesTexts"
                            title="{{ 'FEE-SCHEDULES' | translate }}" [width]="20" [hidden]="true">
                        </kendo-grid-column>
                        <kendo-grid-column field="startDate" [width]="15" title="{{ 'FROM-DATE' | translate }}"
                            filter="date" format="{0:d}">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span>{{intl.formatDate(intl.parseDate(dataItem.startDate), "d")}}</span>
                            </ng-template>
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
                                    <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                    <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                    <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                                    <kendo-filter-after-operator></kendo-filter-after-operator>
                                    <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                                    <kendo-filter-before-operator></kendo-filter-before-operator>
                                </kendo-grid-date-filter-cell>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="endDate" [width]="15" title="{{ 'TO-DATE' | translate }}"
                            filter="date" format="{0:d}">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span>{{intl.formatDate(intl.parseDate(dataItem.endDate), "d")}}</span>
                            </ng-template>
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="lte">
                                    <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                    <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                    <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                                    <kendo-filter-after-operator></kendo-filter-after-operator>
                                    <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                                    <kendo-filter-before-operator></kendo-filter-before-operator>
                                </kendo-grid-date-filter-cell>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="numberOfRecords" [width]="15" filter="numeric" format="{0:n}"
                            title="{{ 'NUMBER-OF-RECORDS' | translate }}" class="text-right">
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                                </kendo-grid-numeric-filter-cell>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="totalAmount" [width]="15" filter="numeric" format="n2"
                            title="{{ 'TOTAL-AMOUNT' | translate }}" class="text-right">
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                                </kendo-grid-numeric-filter-cell>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="createdBy" [width]="15" title="{{ 'CREATED-BY' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="createdOn" [width]="20" title="{{ 'CREATED-DATE' | translate }}"
                            filter="date" format="{0:g}">
                        </kendo-grid-column>
                        <kendo-grid-column field="invoiceStatus" title="{{ 'INVOICE-STATUS' | translate }}" [width]="15"
                            [columnMenu]="false">
                            <ng-template kendoGridFilterCellTemplate let-filter>
                                <app-dropdown-filter [filter]="filter" [data]="invoiceStatuses"
                                    filterField="invoiceStatus" selectDefaultText="{{ 'SELECT-STATUS' | translate }}"
                                    textField="label" valueField="value">
                                </app-dropdown-filter>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div class="text-center">{{dataItem.invoiceStatusText }}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column [width]="15" title="{{ 'ACTIONS' | translate }}" class="text-center">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div class="row m-1">
                                    <div class="col p-0 pr-2"><ng-container
                                            *ngIf="dataItem.invoiceStatus === 'OPEN' || dataItem.invoiceStatus === 'REJECTED' || dataItem.invoiceStatus === 'ERROR'"><i
                                                class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                                                (click)="deleteHandler(dataItem['id'])">
                                            </i>
                                        </ng-container>
                                    </div>
                                    <div class="col p-0 pr-2">
                                        <ng-container *ngIf="dataItem.invoiceStatus === 'ERROR'">&nbsp;<i
                                                class="fas fa-file-import fa-lg pointer" style="color: #bc7410;"
                                                title="{{ 'REGENERATE' | translate }}"
                                                (click)="regenerateHandler(dataItem)">
                                            </i>
                                        </ng-container>
                                    </div>
                                    <div class="col p-0 pr-2">
                                        <ng-container *ngIf="dataItem.invoiceStatus === 'PROCESSED'">&nbsp;<i
                                                class="fas fa-clipboard-check fa-lg pointer" style="color: #bc7410;"
                                                title="{{ 'CLOSE' | translate }}"
                                                (click)="openCloseInvoiceDialogOpened(dataItem)">
                                            </i>
                                        </ng-container>
                                    </div>
                                    <div class="col p-0 pr-2">
                                        <ng-container
                                            *ngIf="!(dataItem.invoiceStatus === 'CLOSED' || dataItem.invoiceStatus === 'PROCESSED')">&nbsp;<i
                                                class="fas fa-sync fa-lg pointer" style="color: #bc7410;"
                                                title="{{ 'UPDATE-IDENTIFIERS' | translate }}"
                                                (click)="openCloseUpdateIdentifiersDialogOpened(dataItem)">
                                            </i>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-grid-command-column>
                    </kendo-grid>
                    <div class="float-right mt-3 mb-3">
                        <button kendoButton [primary]="false" type="button" (click)="generateInvoices()" class="ml-3">
                            {{'GENERATE-INVOICES' | translate}}<i class="far fa-plus"></i>
                        </button>
                        <button kendoButton [primary]="false" type="button" (click)="openPostInvoicesDialogOpened()"
                            [disabled]="selectedInvoiceKeys.length === 0" class="ml-3">
                            {{'POST-INVOICES' | translate}}<i class="far fa-arrow-alt-right"></i>
                        </button>
                    </div>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab
            title="{{ 'RECORDS' | translate }} {{selectedInvoice && showRecordsTab ? '- ' + selectedInvoice.invoiceNumber : ''}}"
            [disabled]="!showRecordsTab">
            <ng-template kendoTabContent>
                <app-invoice-item-list [invoice]="selectedInvoice">
                </app-invoice-item-list>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>

<!--Delete confirmation dialog-->
<kendo-dialog *ngIf="deleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="500"
    (close)="deleteDialogOpened = false">
    <p>{{'CONFIRM-INVOICE-DELETION' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedInvoice.invoiceNumber}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false, selectedInvoice.id)">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true, selectedInvoice.id, true)">{{'YES' |
            translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- Delete invoices dialog -->
<kendo-dialog *ngIf="deleteInvoicesDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="500"
    (close)="cancelDeleteInvoices()">
    <p>{{'CONFIRM-INVOICES-DELETION' | translate}}</p>
    <div *ngIf="selectedInvoicesDeleteInvNumber.length > 0" style="max-height: 300px;">
        <div *ngFor="let item of selectedInvoicesDeleteInvNumber">
            <span class="k-font-weight-bold">{{item}}</span>
        </div>
    </div>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="cancelDeleteInvoices()">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton type="button" (click)="deleteInvoices()">
            {{'YES' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Post confirmation dialog-->
<kendo-dialog *ngIf="postInvoicesDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="500"
    (close)="cancelPostInvoices()">
    <p>{{'CONFIRM-INVOICES-POST' | translate}}</p>
    <div *ngIf="selectedInvoicesPostInvNumber.length > 0" style="max-height: 300px;">
        <div *ngFor="let item of selectedInvoicesPostInvNumber">
            <span class="k-font-weight-bold">{{item}}</span>
        </div>
    </div>
    <div *ngIf="selectedInvoicesRepostInvNumber.length > 0" style="max-height: 300px;">
        <div *ngFor="let item of selectedInvoicesRepostInvNumber">
            <span class="k-font-weight-bold">{{item}}</span>
        </div>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelPostInvoices()">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="postInvoices()">{{'YES' |
            translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- Close invoice dialog -->
<kendo-dialog *ngIf="closeInvoiceDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="500"
    (close)="cancelCloseInvoice()">
    <p>{{'CONFIRM-INVOICE-CLOSE' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedInvoiceModal.invoiceNumber}}</span>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="cancelCloseInvoice()">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton type="button" (click)="closeInvoice()">
            {{'YES' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- Update all identifiers dialog -->
<kendo-dialog *ngIf="updateIdentifiersDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="500"
    (close)="cancelCloseUpdateIdentifiers()">
    <p>{{'CONFIRM-UPDATE-IDENTIFIERS' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedInvoiceModal.invoiceNumber}}</span>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="cancelCloseUpdateIdentifiers()">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton type="button" (click)="updateInvoiceIdentifiers()">
            {{'YES' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>